import type { ComputedRef, InjectionKey } from 'vue';
import type { ResponseMarks, ValidationIssue } from '@record-fill';

/** Cell ids by table id, on each side of a page cut that falls between two rows of the table. */
export interface ChunkEdges {
  bottom: Record<string, string[]>;
  top: Record<string, string[]>;
}

export interface FillContext {
  highlightedFieldId: ComputedRef<string | null>;
  extraIssuesByField: ComputedRef<Record<string, ValidationIssue[]>>;
  showAnchorHighlights: ComputedRef<boolean>;
  showCompiledIssues: ComputedRef<boolean>;
  readOnly: ComputedRef<boolean>;
  changeMarks: ComputedRef<ResponseMarks | null>;
  showHighlights: ComputedRef<boolean>;
  chunkEdges?: ComputedRef<ChunkEdges | null>;
  onFocusField: (fieldId: string) => void;
}

export const FILL_CONTEXT_KEY: InjectionKey<FillContext> = Symbol('fill-context');

// The new row "−" will take, provided by each multiple table to its own cells, so moving the
// selection updates the two rows involved instead of re-rendering the whole table.
export const SELECTED_NEW_ROW_KEY: InjectionKey<ComputedRef<number | null>> = Symbol('selected-new-row');
